import { z } from 'zod';
import { apiClient } from '../client';

/**
 * The caller's "Envoyer au CRM" button (2026-09-22). A qualified call is sent
 * to the CRM of the client the prospect belongs to; the server resolves
 * which one (Swoft outbox or HubSpot) and answers 409 with a French message
 * when that client has no CRM.
 */

export const CrmSendResultSchema = z.object({
  provider: z.enum(['none', 'hubspot', 'swoft']),
  status: z.enum(['not_configured', 'not_sent', 'pending', 'delivered', 'failed', 'dead']).optional(),
  lastError: z.string().optional(),
  sentAt: z.string().optional(),
  customerName: z.string().optional(),
});

export type CrmSendResult = z.infer<typeof CrmSendResultSchema>;

export async function getCallCrmStatus(callId: string, opts?: { signal?: AbortSignal }): Promise<CrmSendResult> {
  const raw = await apiClient.get<unknown>(`/integrations/crm/calls/${encodeURIComponent(callId)}/status`, opts);
  return CrmSendResultSchema.parse(raw);
}

export async function sendCallToCrm(callId: string): Promise<CrmSendResult> {
  const raw = await apiClient.post<unknown>(`/integrations/crm/calls/${encodeURIComponent(callId)}/send`, {});
  return CrmSendResultSchema.parse(raw);
}
